export default "__VITE_ASSET__BCHoH1Uo__"